import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OnboardingSurveyCompleted } from '../types';
import META from './useTrackCompletedOnboardingJobTitle.meta';

export const useTrackCompletedOnboardingJobTitle = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingJobTitle = useCallback(
    (params: OnboardingSurveyCompleted) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackCompletedOnboardingJobTitle };
};
